import { cn } from '@shadcn/lib/utils';
import { ArrowLeft } from 'lucide-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export function BackLink({ className, text, onBack }: IBackLinkProps) {
  const { t } = useTranslation();
  const backText = text ?? t('navigation.back');

  const handleBack = useCallback(() => {
    if (onBack) {
      onBack();
    } else if (typeof window !== 'undefined' && window.history) {
      window.history.back();
    }
  }, [onBack]);

  return (
    <button
      className={cn('flex items-center gap-2 py-5 text-left hover:bg-gray-50', className)}
      onClick={handleBack}
      type="button"
    >
      <ArrowLeft className="w-6 h-6" />
      <div className="text-slate-800 text-lg font-semibold">{backText}</div>
    </button>
  );
}

export interface IBackLinkProps {
  readonly text?: string;
  readonly className?: string;
  readonly onBack?: () => void;
}
